import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/rocket_500.png'


const _withScopeId = n => (_pushScopeId("data-v-162a5f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " You have reached the sharing limit for your current plan. ", -1))
const _hoisted_2 = { class: "limit-details" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Current plan:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sharing limit:", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "count" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " This is the total number of unique users or invited users in all the groups you own, except groups that are only sharing trees that are \"free to share\". ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "upgrade-icon"
}, null, -1))

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSharingLimiter } from './SharingLimiter'
import { useModalAutoHide } from '@/util/AppUtil'
import { useUserStore } from '@/gp/UserStore'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { LoadMode } from '@/util/AsyncData'
import { defaultPlanId, subscriptionPlans } from '@/gp/GroupAdminModel'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SharingLimitReachedModal',
  setup(__props, { expose: __expose }) {

__expose({
  open: () => modalRef.value?.open(),
})

const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const subscriptionStore = useSubscriptionStore()
const sharingLimiter = useSharingLimiter()
const router = useRouter()
useModalAutoHide(modalRef)

const sharingLimitRef = computed(() => userStore.getAsyncSelf()?.data?.limits?.sharingLimit ?? 0)
const subRef = computed(() => subscriptionStore.getSubscriptionListForSelf(LoadMode.EnsureLoaded).at(0))
const priceRef = computed(() => subRef.value?.items.at(0)?.price)
const planRef = computed(() => subscriptionPlans.find(p => p.id == (priceRef.value?.productId ?? defaultPlanId)))

async function showPlansPage() {
  router.push("/plans")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "sharing-limit-reached-modal",
    onOk: showPlansPage
  }, {
    title: _withCtx(() => [
      _createTextVNode("Sharing limit reached")
    ]),
    okText: _withCtx(() => [
      _hoisted_8,
      _createTextVNode(" Upgrade plan ")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, _toDisplayString(planRef.value?.displayName), 1),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(sharingLimitRef.value), 1),
          _createTextVNode(" users ")
        ])
      ]),
      _hoisted_7
    ]),
    _: 1
  }, 512))
}
}

})